import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskPoliciesRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-policies',
	path: '/jira/servicedesk/projects/:projectKey/settings/policies',
	exact: true,
};
